
.flex1 {
  flex: 1;
}

.table {
  position: relative;
  z-index: 1;
  background-color: var(--static-background-strong);
}

.productCell { 
  padding: 0.25rem;
}

.minWidth0 {
  display: inline-block;
  text-align: left;

  min-width: 0;
  max-width: 15rem;
  text-overflow: ellipsis;
  white-space: wrap;
  overflow: hidden;

  display: -webkit-box;
  -webkit-box-orient: vertical;  
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.nowrap {
  white-space: nowrap;;
}

.categoryName {
  display: inline-block;
  text-align: left;
  width: 8rem;
  max-width: 8rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.zeroState {
  width: 100%;
  height: 20rem;
  background-color: var(--static-background-strong);
  display: flex;
  justify-content: center;
  align-items: center;
}

.brandCards {
  overflow-x: scroll;
  padding-bottom: 1rem;
}

.brandCard {
  flex-shrink: 0;
  width: 15rem;
  aspect-ratio: 3/2;
  padding: 1rem;
  background-color: var(--static-background-strong);
  border-radius: 0.5rem;
  border: 1px solid var(--static-divider-standard);
}

.searchButton {
  width: 10rem;
}
